import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: "pusher",
  key: "1cb975d9a1102a052865",
  cluster: "ap1",
  forceTLS: true,
});

export default echo;
